/* src/app/admin-dashboard/site-system/category/sites-category-popup/sites-category-popup.css */
::ng-deep sites-category-popup.ng-star-inserted > div {
  margin-right: -24px;
  margin-left: -24px;
}
/*# sourceMappingURL=sites-category-popup.css.map */
